module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "author"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Author’s Note")])])]), _c('a', {
    attrs: {
      "id": "author"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A crime novelist, by virtue of his unpleasant craft, has the duty to create at least one highly reprehensible character in each book and it is perhaps inevitable that from time to time their sanguinary misdeeds should impinge upon the dwellings of the just. A writer whose characters have chosen to act out their tragicomedy in an ancient university city is in particular difficulty. He can, of course, call it Oxbridge, invent colleges named after improbable saints and send his characters boating on the Camsis, but this timid compromise merely confuses characters, readers and the author alike, with the result that no one knows precisely where he is and two communities are offered opportunities for offence instead of one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The greater part of this story is unrepentantly set in Cambridge, a city in which, undeniably, there live and work policemen, coroners, doctors, students, college servants, flower sellers, Dons, scientists, and even, no doubt, retired Majors. None of them, to my knowledge, bears the slightest resemblance to his counterpart in this book. All the characters, even the most unpleasant, are imaginary; the city, happily for us all, is not.")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "author"
    }
  }, [_vm._v("P. D. J.")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c6c8dca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/a_author.vue
// module id = 81
// module chunks = 0